import { acquireCart, root, readCart, cleanProperties, changeLine, findLine, sameProperties } from '@theme/pf-cart-client';
import { validateFields, showFieldError, guideToField } from '@theme/pf-validation';
const message = key => document.querySelector('[data-pf-custom-messages]')?.dataset[key] || '';
document.addEventListener('click', async event => {
  const button = event.target.closest?.('[data-pf-save-custom]');
  if (!button || button.disabled) return;
  event.preventDefault();
  const editor = button.closest('[data-pf-cart-custom]');
  const status = editor.querySelector('[data-pf-editor-feedback]');
  const fields = [...editor.querySelectorAll('[data-pf-property]')];
  const invalid = validateFields(editor, { guide: false });
  for (const field of fields) {
    if (!field.value.trim() && !invalid.includes(field)) { showFieldError(field, message('required')); invalid.push(field); }
  }
  if (invalid.length) { guideToField(invalid[0]); return; }
  let release;
  button.disabled = true;
  const label = button.textContent;
  button.textContent = message('saving');
  try {
    release = acquireCart();
    const cart = await readCart();
    const line = cart.items.find(item => item.key === editor.dataset.cartKey);
    if (!line) throw new Error('line');
    const props = cleanProperties(line.properties);
    for (const field of fields) props[field.dataset.pfProperty] = field.value.trim();
    if (props['Product colour']) { delete props['Colour & finish']; delete props['Colour &amp; finish']; }
    const result = await changeLine(line, line.quantity, props);
    const updated = result.items.find(item => item.variant_id === line.variant_id && sameProperties(item.properties, props));
    if (!updated || updated.quantity !== line.quantity) throw new Error('save');
    const current = findLine(await readCart(), updated);
    if (!current || !sameProperties(current.properties, props)) throw new Error('save');
    status.textContent = message('saved');
    location.assign(root() + 'cart');
  } catch { status.textContent = message('error'); button.disabled = false; button.textContent = label; }
  finally { release?.(); }
});
const blocked = () => !!document.querySelector('[data-pf-checkout-blocked="true"]');
function stop(event) {
  event.preventDefault(); event.stopImmediatePropagation();
  document.querySelector('.pf-cart-alert,.pf-cart-design-error')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
}
document.addEventListener('click', event => { if (event.target.closest?.('[name="checkout"],[data-pf-checkout-link]') && blocked()) stop(event); }, true);
document.addEventListener('submit', event => { if ((event.submitter?.name === 'checkout' || event.target.id === 'cart-form') && blocked()) stop(event); }, true);

